import { render, staticRenderFns } from "./SidebarChart.vue?vue&type=template&id=77b98bf9&"
import script from "./SidebarChart.vue?vue&type=script&lang=js&"
export * from "./SidebarChart.vue?vue&type=script&lang=js&"
import style0 from "./SidebarChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports